var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
!_vm.item.gravity ? ''
:_vm.item.gravity==='center'?'grvC'
:_vm.item.gravity==='bottom'?'grvB'
: ''
],style:([
  {fontSize: _vm.item.size === 'xxs' ? '11px'
  : _vm.item.size === 'xs' ? '13px'
  : _vm.item.size === 'sm' ? '14px'
  : _vm.item.size === 'md' ? '16px'
  : _vm.item.size === 'lg' ? '19px'
  : _vm.item.size === 'xl' ? '22px'
  : _vm.item.size === 'xxl' ? '29px'
  : _vm.item.size === '3xl' ? '35px'
  : _vm.item.size === '4xl' ? '48px'
  : _vm.item.size === '5xl' ? '74px'
  : _vm.item.size, fontWeight: _vm.item.weight},
  _vm.item.color?{color: _vm.item.color}:{},
  _vm.item.align?{
    textAlign: _vm.item.align,
    justifyContent: _vm.item.align
  }:{}
])},[(_vm.item.contents&&_vm.item.contents.length>0)?_vm._l((_vm.item.contents),function(txt,t){return _c('span',{key:t,style:([
  txt.size?{
    fontSize: txt.size === 'xxs' ? '11px'
  : txt.size === 'xs' ? '13px'
  : txt.size === 'sm' ? '14px'
  : txt.size === 'md' ? '16px'
  : txt.size === 'lg' ? '19px'
  : txt.size === 'xl' ? '22px'
  : txt.size === 'xxl' ? '29px'
  : txt.size === '3xl' ? '35px'
  : txt.size === '4xl' ? '48px'
  : txt.size === '5xl' ? '74px'
  : txt.size
  }:{},
  txt.weight?{fontWeight: txt.weight}:{},
  txt.color?{color: txt.color}:{},
  txt.style?{fontStyle: txt.style}:{},
  txt.decoration?{textDecoration: txt.decoration}:{},
])},[_vm._v(_vm._s(txt.text))])}):_c('p',{style:([
  _vm.item.size?{
    fontSize: _vm.item.size === 'xxs' ? '11px'
  : _vm.item.size === 'xs' ? '13px'
  : _vm.item.size === 'sm' ? '14px'
  : _vm.item.size === 'md' ? '16px'
  : _vm.item.size === 'lg' ? '19px'
  : _vm.item.size === 'xl' ? '22px'
  : _vm.item.size === 'xxl' ? '29px'
  : _vm.item.size === '3xl' ? '35px'
  : _vm.item.size === '4xl' ? '48px'
  : _vm.item.size === '5xl' ? '74px'
  : _vm.item.size
  }:{},
  _vm.item.weight?{fontWeight: _vm.item.weight}:{},
  _vm.item.color?{color: _vm.item.color}:{},
  _vm.item.align?{textAlign: _vm.item.align}:{},
])},[_vm._v(_vm._s(_vm.item.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }